import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '../routes';
import { useLanguageContext } from '../context/LanguageContext';

const RoutesWrapper = ({ children }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { lastLanguageChange, setLastLanguageChange } = useLanguageContext();

  useEffect(() => {
    const { pathname } = window.location;
    const isEnglishPath = pathname.startsWith('/en');
    const routeLanguage = isEnglishPath ? 'en' : 'es';
    const activeLanguage = lastLanguageChange ? routeLanguage : i18n.language;

    document.documentElement.lang = activeLanguage === 'en' ? 'en' : 'es-MX';

    if (lastLanguageChange) {
      if (i18n.language !== routeLanguage) {
        i18n.changeLanguage(routeLanguage);
      }
      setLastLanguageChange(false);
    }

    if (pathname === '/') {
      const defaultLang = activeLanguage === 'en' ? '/en' : '/';
      navigate(defaultLang, { replace: true });
      return;
    }

    if (pathname === '/en' && activeLanguage !== 'en') {
      navigate('/', { replace: true });
      return;
    }

    if (pathname.endsWith('/')) {
      navigate(pathname.slice(0, -1), { replace: true });
      return;
    }

    const isEnglish = pathname.startsWith('/en');
    const newLanguagePrefix = activeLanguage === 'en' ? '/en' : '';
    const basePath = isEnglish ? pathname.replace(/^\/en/, '') : pathname;

    const currentRoute = isEnglish
      ? routes.en.find((route) => route.path.includes(basePath))
      : routes.es.find((route) => route.path.includes(basePath));

    const translatedPath =
      (activeLanguage === 'en'
        ? routes.en.find((route) => route.id === currentRoute?.id)?.path
        : routes.es.find((route) => route.id === currentRoute?.id)?.path) ||
      `${newLanguagePrefix}${basePath}`;

    if (translatedPath !== pathname && translatedPath !== basePath) {
      navigate(translatedPath, { replace: true });
    }
  }, [i18n.language, navigate, lastLanguageChange, setLastLanguageChange, i18n]);

  return <>{children}</>;
};

export default RoutesWrapper;
